import React from 'react';
import ReactDOM from 'react-dom';
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';
import classnames from 'classnames';
import styles from './styles.css';

export class Swipers extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hideNavigation: true,
            activeSlideIndex: -1,
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.update);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.update);
    }

    update(){
        if(this.swiper){
            this.swiper.update();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(!this.swiper){
            // console.log('no swipper');
            // let getCarouselCurrentStep = this.props.getCarouselCurrentStep ? this.props.getCarouselCurrentStep : function(){};
            // let getSlideChangeStep = this.props.getSlideChangeStep ? this.props.getSlideChangeStep : function(){};
            this.swiper = new Swiper(this.swiperContainer, {
                // resistance: true,
                // resistanceRatio: 0,
                // freeModeSticky: true,
                // freeModeMomentumBounce: false,
                // freeModeMomentum: false,
                // centeredSlides: true,
                roundLengths: true,
                watchOverflow: true,
                slidesPerView: this.props.slidesPerView.mobile,
                // slidesPerView: this.props.slidesPerView.mobile,
                spaceBetween: this.props.spaceBetween.mobile,
                freeMode: true,
                roundLengths: true,
                slidesOffsetBefore: this.props.slidesOffsetBefore,
                breakpoints: {
                    // when window width is >= 993px
                    993: {
                      slidesPerView: this.props.slidesPerView.desk,
                      spaceBetween: this.props.spaceBetween.desk,
                    }
                  },
                // Navigation arrows
                navigation: {
                    nextEl: this.swiperBtnNext,
                    prevEl: this.swiperBtnPrev,
                },
                on: {
                    slideChange: (function(){
                        if(this.props.getSlideChangeStep){
                            // console.log(`Swiper | slideChange | activeIndex: ${this.swiper.activeIndex}`);
                            this.props.getSlideChangeStep(this.swiper.activeIndex);
                        }
                    }).bind(this),
                }
            });
            // this.swiper.update();
        } else {
            if(this.state.offsetWidth != this.swiperContainer.offsetWidth ||
                this.props.step != prevProps.step ||
                this.props.children.length != prevProps.children.length ||
                this.props.children.findIndex(s => s.props.shade && s.props.shade.active) != this.state.activeSlideIndex){

                    this.swiper.update(); //fix to update this.swiper.slides
                    
                    // console.log(`Swiper | navigationClass: ${this.props.navigationClass} | offsetWidth: ${this.swiperContainer.offsetWidth}`);

                    const nextState = {};

                    if(this.swiper.slides[0]){
                        const seletedIndex = this.props.children.findIndex(s => {
                            return (s.props.shade && s.props.shade.active) || 
                            (s.props.product && s.props.product.active);
                        });

                        const slideBCR = this.swiper.slides[0].getBoundingClientRect();
                        const left = slideBCR.left;
                        const right = this.swiper.slides[this.swiper.slides.length - 1].getBoundingClientRect().right;

                        const wrapperBCR = this.swiper.$el[0].getBoundingClientRect();

                        const slidesShown = Math.floor(wrapperBCR.width / slideBCR.width) - 1;

                        nextState.hideNavigation = this.props.hideNavigation || slidesShown > this.swiper.slides.length;
                        
                        if(seletedIndex >= 0 && this.swiper.slides[seletedIndex]){
                            const selectedSlideBCR = this.swiper.slides[seletedIndex].getBoundingClientRect();
                            const leftDiff = selectedSlideBCR.left - wrapperBCR.left;
                            const rightDiff = selectedSlideBCR.right - wrapperBCR.right;
                            if(rightDiff > 0 || leftDiff < 0){
                                // console.log(`no visible | navigationClass: ${this.props.navigationClass} | slidesShown: ${slidesShown}`);
                                const currTranslate = this.swiper.getTranslate();
                                let nextTranslate;
                                if(rightDiff > 0){ // move left
                                    nextTranslate = currTranslate - rightDiff;
                                } else {
                                    nextTranslate = currTranslate - leftDiff;
                                }
                                // console.log(`Swiper | navigationClass: ${this.props.navigationClass}currTranslate: ${currTranslate} | nextTranslate: ${nextTranslate}`);
                                this.swiper.setTranslate(nextTranslate);
                            } else {
                                // console.log(`Swiper | navigationClass: ${this.props.navigationClass}visible | slidesShown: ${slidesShown}`);
                            }
                            const middle = wrapperBCR.left - wrapperBCR.right;
                        } else if(this.props.step != prevProps.step){
                            const index = Math.floor(this.props.step ? this.props.step : 0);
                
                            // console.log(`Swipper | navigationClass: ${this.props.navigationClass} | carousel slideTo index: ${index} - step: ${this.props.step}`);
                            
                            this.swiper.slideTo(index);
                        }
                    }

                    nextState.offsetWidth = this.swiperContainer.offsetWidth;
                    nextState.activeSlideIndex = this.props.children.findIndex(s => s.props.shade && s.props.shade.active);

                    this.setState(nextState);
                    // this.swiper.update();
            }
        }
    }

    render() {
        const hideNavigation = this.state.hideNavigation ? 'none' : '';
        const narrowSwiper = this.props.hideNavigation ? '' : this.props.products ? styles.narrowSwiper2 : styles.narrowSwiper;
        const narrowSwiperWrap = this.props.hideNavigation ? '' : styles.narrowSwiperWrap;
        const noSwiping = this.props.noSwiping ? 'swiper-no-swiping' : '';
        return (
            <div className={classnames(noSwiping, narrowSwiperWrap)}>
                
                <div ref={node => (this.swiperBtnPrev = node)} 
                style={{
                    display: hideNavigation
                }} 
                className={classnames(this.props.navigationClass, styles.arrow)}
                // className={classnames(styles.arrow, 'swiper-button-prev')}
                >
                    {this.props.navigationIcon}
                </div>
                {/* <!-- Slider main container --> */}
                <div ref={node => (this.swiperContainer = node)} className={classnames(narrowSwiper, 'swiper-container')}>
                    {/* <!-- Additional required wrapper --> */}
                    <div ref={node => (this.swiperWrapper = node)} className={classnames('swiper-wrapper')}>
                        {/* <!-- Slides --> */}
                        {
                            this.props.children.map((c, i) => {
                                return (
                                <div key={i} className={classnames(styles.swiperSlide, 'swiper-slide')}>
                                    {/* {i} */}
                                    {c}
                                </div>
                                )
                            })
                        }

                    </div>
                    {/* <!-- If we need pagination --> */}
                    {/* <div class="swiper-pagination"></div> */}

                    {/* <!-- If we need scrollbar --> */}
                    {/* <div class="swiper-scrollbar"></div> */}
                </div>
                
                {/* <!-- If we need navigation buttons --> */}
                <div ref={node => (this.swiperBtnNext = node)} 
                style={{
                    display: hideNavigation
                }} 
                className={classnames(this.props.navigationClass, styles.arrow, styles.reverse)}
                // className={classnames(styles.arrow, 'swiper-button-next')}
                >
                    {this.props.navigationIcon}
                </div>
            </div>
        );
    }
}